import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => {
  const cardWidth = '327px'
  const cardHeight = '514px'
  const cardBallWidth = '327px'
  const avatarSize = '92px'
  return {
    name: {
      wordBreak: 'break-word',
    },
    modal: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    cardContainer: {
      position: 'absolute',
      maxWidth: cardWidth,
      width: cardWidth,
      height: cardHeight,
      maxHeight: cardHeight,
      borderRadius: '15px',
      overflow: 'unset',
    },
    closeButton: {
      position: 'absolute',
      cursor: 'pointer',
      top: '10px',
      right: '10px',
      color: '#fff',
      zIndex: '100',
    },
    avatar: {
      position: 'absolute',
      width: avatarSize,
      height: avatarSize,
      left: `calc(${cardWidth}/2 - ${avatarSize} / 2)`,
      top: 0,
      marginTop: -42,
    },
    cardMediaBall: {
      position: 'absolute',
      bottom: 0,
      left: `calc(${cardWidth}/2 - ${cardBallWidth} / 2)`,
      width: cardBallWidth,
      height: 'auto',
      margin: 'auto',
      zIndex: 1,
    },
    website: {
      opacity: 0.5,
      marginBottom: theme.spacing(2),
      wordBreak: 'break-word',
    },
    logo: {
      flexShrink: 0,
      height: 34,
      color: '#fff',
    },
    execLogo: {
      maxWidth: '250px',
      marginBottom: 90,
    },
    membershipDate: {
      opacity: 0.5,
      marginTop: 6,
    },
  }
})
